import { render, staticRenderFns } from "./XUpImg.vue?vue&type=template&id=18d814c9&scoped=true"
import script from "./XUpImg.vue?vue&type=script&lang=js"
export * from "./XUpImg.vue?vue&type=script&lang=js"
import style0 from "./XUpImg.vue?vue&type=style&index=0&id=18d814c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d814c9",
  null
  
)

export default component.exports